<template>
    <article v-if="item !== null" class="testimonials" :class="getModuleThemeClass()" data-action="testimonials-swiper" :data-swiper-container="(`swiper${item.id}`)" data-swiper-pagination="false" data-swiper-effect="fade">
        <div :id="(`swiper${item.id}`)" class="testimonials__wrap">
            <div class="testimonials__list swiper-wrapper">
                <div v-for="(testimonial, index) in item.Testimonials" :key="index" class="testimonials__item swiper-slide">
                    <blockquote class="testimonials__quote">
                        <span class="testimonials__icon">
                            <svg id="uuid-cbaa723b-2cd9-482b-bb97-cb87680d7345" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 38.543">
                                <path d="m42.412,16.334l4.299.143v22.066h-18.627V15.905L40.12,0l7.881,5.015-6.305,10.89.716.43Zm-27.94,0h4.299v22.209H0V15.905L12.179,0l7.881,5.015-6.304,10.89.717.43Z" />
                            </svg>
                        </span>
                        <div class="rich-text testimonials__rich-text" v-html="testimonial.Link.RichText"></div>
                    </blockquote>
                    <div class="testimonials__contact-wrap">
                        <img class="testimonials__image" :src="getImagePath(testimonial.Link.Image)" alt="@testimonialName" />
                        <div class="testimonials__contact">
                            <span class="testimonials__name">{{ testimonial.Link.Name }}</span>
                            <span class="testimonials__company">{{ testimonial.Link.Company }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="testimonials__nav">
                <span class="testimonials__prev btn__prev">
                    <svg id="uuid-a3836ad2-cceb-4317-84a9-034b0af41477" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.936 11.122"><path d="m15.376,10.061l4.5-4.501L15.376,1.061M.75,5.561h18.001" style="fill:none; stroke:#fff; stroke-linecap:square; stroke-width:1.5px;"/></svg>
                </span>
                <span class="testimonials__next btn__next">
                    <svg id="uuid-a3836ad2-cceb-4317-84a9-034b0af41477" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.936 11.122"><path d="m15.376,10.061l4.5-4.501L15.376,1.061M.75,5.561h18.001" style="fill:none; stroke:#fff; stroke-linecap:square; stroke-width:1.5px;"/></svg>
                </span>
            </div>
        </div>
    </article>
</template>
<script>
import { setupSwipers } from '../../components/swiper';
import { useItem } from '../composables/item';
const { getThemeClass } = useItem();

export default {
    name: 'Testimonials',
    props: {
        item: {
            type: Object,
            default: null,
        }
    },
    mounted() {
        setupSwipers('[data-action="testimonials-swiper"]');
    },
    methods: {
        getModuleThemeClass() {
            return getThemeClass(this.item);
        },
        getImagePath(image) {
            return `/admin/public/getimage.ashx?image=${image.PathUrlEncoded}&x=${image.FocalX}&y=${image.FocalY}&width=90&height=90&crop=7&format=jpg`;
        }
    }
};
</script>
